/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoTextareaComponent = {
    template: require('./gmao-textarea.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        maxLength: '<',
        placeholderKey: '<',
        hintKey: '<',
        autogrow: '<',
        rows: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoTextarea.js